export default "__VITE_PUBLIC_ASSET__18178d39__"